import DefaultColumn from "components/Table/components/DefaultColumn";
import { MdRemoveRedEye } from "react-icons/md";

const TABLE_COLUMN = (onClickDetail) => [
  {
    accessorKey: "product.product_name",
    header: "Nama",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
    size: 500,
  },
  {
    accessorKey: "gudang.gudang_name",
    header: "Wilayah",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "stok",
    header: "Stok",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "unit.unit_name",
    header: "Satuan",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "unit.unit_name",
    header: "Aksi",
    cell: (info) => (
      <div className="flex gap-1">
        <button
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#EBFAF0] text-[#215759]"
          onClick={() => onClickDetail(info.row.original)}
        >
          <MdRemoveRedEye />
        </button>
      </div>
    ),
  },
];

export { TABLE_COLUMN };
